var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4023 16.4075L13.4191 12.4243C14.4633 11.1552 15.0926 9.52744 15.0926 7.75557C15.0926 3.69502 11.802 0.400879 7.73789 0.400879C3.67383 0.400879 0.386719 3.69502 0.386719 7.75557C0.386719 11.8161 3.67734 15.1103 7.74141 15.1103C9.51328 15.1103 11.1375 14.4845 12.4066 13.4403L16.3898 17.4235C16.5727 17.6099 17.1316 17.7013 17.4059 17.4235C17.6836 17.1423 17.6836 16.6888 17.4023 16.4075Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.67601,
    cy: 7.67674,
    r: 5.55882,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1883 7.03828H8.45508V5.30508C8.45508 4.90781 8.13516 4.58789 7.73789 4.58789C7.34063 4.58789 7.0207 4.90781 7.0207 5.30508V7.03828H5.2875C4.89023 7.03828 4.57031 7.3582 4.57031 7.75547C4.57031 8.15273 4.89023 8.47266 5.2875 8.47266H7.0207V10.2059C7.0207 10.6031 7.34063 10.923 7.73789 10.923C8.13516 10.923 8.45508 10.6031 8.45508 10.2059V8.47266H10.1883C10.5855 8.47266 10.9055 8.15273 10.9055 7.75547C10.9055 7.3582 10.582 7.03828 10.1883 7.03828Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.5d648cb4e84a8de87403e546a062dca2.svg";
export { ForwardRef as ReactComponent };